module.exports = __webpack_public_path__ + "img/tarot-major-arcana-12.1d6681c9.png";